import React, { useEffect, useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import './DashForm.css';

// Découpe une liste en pages ; revient à la page 1 quand le nombre d'éléments change
export function usePagination(items, pageSize = 6) {
  const [page, setPage] = useState(1);
  const totalPages = Math.max(1, Math.ceil((items?.length || 0) / pageSize));
  const current = Math.min(page, totalPages);

  useEffect(() => {
    setPage(1);
  }, [items?.length]);

  const pageItems = (items || []).slice((current - 1) * pageSize, current * pageSize);
  return { page: current, totalPages, pageItems, setPage, total: items?.length || 0 };
}

export default function Pagination({ page, totalPages, total, onChange }) {
  if (totalPages <= 1) return null;

  const pages = [];
  const start = Math.max(1, Math.min(page - 2, totalPages - 4));
  const end = Math.min(totalPages, start + 4);
  for (let i = start; i <= end; i++) pages.push(i);

  return (
    <nav className="dash-pagination" aria-label="Pagination">
      <button
        type="button"
        className="dash-pagination-btn"
        onClick={() => onChange(page - 1)}
        disabled={page <= 1}
        aria-label="Page précédente"
      >
        <ChevronLeft size={15} />
      </button>
      {start > 1 && (
        <>
          <button type="button" className="dash-pagination-btn" onClick={() => onChange(1)}>1</button>
          {start > 2 && <span className="dash-pagination-ellipsis">…</span>}
        </>
      )}
      {pages.map((n) => (
        <button
          key={n}
          type="button"
          className={`dash-pagination-btn${n === page ? ' is-active' : ''}`}
          onClick={() => onChange(n)}
          aria-current={n === page ? 'page' : undefined}
        >
          {n}
        </button>
      ))}
      {end < totalPages && (
        <>
          {end < totalPages - 1 && <span className="dash-pagination-ellipsis">…</span>}
          <button type="button" className="dash-pagination-btn" onClick={() => onChange(totalPages)}>{totalPages}</button>
        </>
      )}
      <button
        type="button"
        className="dash-pagination-btn"
        onClick={() => onChange(page + 1)}
        disabled={page >= totalPages}
        aria-label="Page suivante"
      >
        <ChevronRight size={15} />
      </button>
    </nav>
  );
}
